import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:     "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:   "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline:     "text-foreground",
        // ── Signal types ──────────────────────────────────────────────────────
        trend:       "bg-teal-50 text-teal-700 border-teal-200",
        opportunity: "bg-emerald-50 text-emerald-700 border-emerald-200",
        anomaly:     "bg-amber-50 text-amber-700 border-amber-200",
        contrarian:  "bg-rose-50 text-rose-700 border-rose-200",
        // ── Epistemic status ──────────────────────────────────────────────────
        insight:     "bg-blue-50 text-blue-700 border-blue-200",
        theory:      "bg-purple-50 text-purple-700 border-purple-200",
        learning:    "bg-emerald-50 text-emerald-700 border-emerald-200",
        evidence:    "bg-slate-100 text-slate-600 border-slate-200",
        decision:    "bg-indigo-50 text-indigo-700 border-indigo-200",
        // ── Source authority ──────────────────────────────────────────────────
        official:    "bg-slate-900 text-white border-transparent",
        consulting:  "border-violet-400 text-violet-700 bg-violet-50",
        media:       "border-slate-300 text-slate-600 bg-white",
        industry:    "border-blue-400 text-blue-700 bg-blue-50",
        // ── Decision / feed status ────────────────────────────────────────────
        active:      "bg-emerald-50 text-emerald-700 border-emerald-200",
        superseded:  "bg-slate-100 text-slate-500 border-slate-200",
        reversed:    "bg-rose-50 text-rose-700 border-rose-200",
        pending:     "bg-amber-50 text-amber-700 border-amber-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
